module.exports = __webpack_public_path__ + "img/upsell-hifi-payouts-mobile.9115c42.png";